import { createBrowserRouter } from 'react-router-dom';

import { adminRoutes } from '../features/admin/adminRoutes';
import { PublicSitePage } from '../features/public/PublicSitePage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicSitePage />,
  },
  ...adminRoutes,
]);
